import React from 'react';
import { AssetsContext } from 'provider/AssetsProvider';

const useAssets = () => React.useContext(AssetsContext);

export default useAssets;
